module.exports = __webpack_public_path__ + "img/32.b45cee97.png";